import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import salonaccessApiController from "../../services/salonaccess.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
export const usersAdapter = createEntityAdapter();

const salonAccessErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const salonaccessStoreApi = createAsyncThunk("salonaccess/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await salonaccessApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const salonaccessUpdateApi = createAsyncThunk("salonaccess/update", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await salonaccessApiController
      .update(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const salonaccessListViewApi = createAsyncThunk("salonaccess/gridview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonaccessApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "gridview"))
      .catch((error) => HandleError(thunkAPI, error, "gridview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const salonaccessOptions = createAsyncThunk("salonaccess/salonaccessOptions", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonaccessApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "salonaccessOptions"))
      .catch((error) => HandleError(thunkAPI, error, "salonaccessOptions"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const salonaccessDetailApi = createAsyncThunk("salonaccess/detail", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonaccessApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "detail"))
      .catch((error) => HandleError(thunkAPI, error, "detail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const salonaccessDeleteApi = createAsyncThunk("salonaccess/delete", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonaccessApiController
      .deleted(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "delete"))
      .catch((error) => HandleError(thunkAPI, error, "delete"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const salonaccessSuggetionListApi = createAsyncThunk("salonaccess/suggetionlist", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonaccessApiController
      .suggetionlist(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "suggetionlist"))
      .catch((error) => HandleError(thunkAPI, error, "suggetionlist"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isOpenedAddForm: "",
  isOpenedEditForm: "",
  isOpenedDetailModal: "",
  isListView: [],
  isListViewError: "",
  isSuggetionListView: [],
  isSuggetionListViewError: "",
  isDetailData: "",
  isDetailDataError: "",
  isSearchList: "",
  isSearchName: "",
  isCategoryOption: [],
  isCategoryOptionError: "",
  isStoreError: "",
  isUpdateError: "",
  isDeleteError: "",
  isApiStatus: {
    salonaccessStoreApi: "",
    salonaccessUpdateApi: "",
    salonaccessListViewApi: "",
    salonaccessSuggetionListApi: "",
    salonaccessDetailApi: "",
    salonaccessDeleteApi: "",
    salonaccessOptions: "",
  },
};

const salonaccessSlice = createSlice({
  name: "salonaccess",
  initialState,
  reducers: {
    reset: () => initialState,
    openAddCategoryForm: (state = initialState) => {
      state.isOpenedEditForm = "";
      state.isOpenedAddForm = "open";
    },
    closeAddCategoryForm: (state = initialState) => {
      state.isOpenedEditForm = "";
      state.isOpenedAddForm = "";
    },
    openEditCategoryForm: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedEditForm = "open";
    },
    closeEditCategoryForm: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedEditForm = "";
    },
    openCategoryDetailModal: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedDetailModal = "open";
    },
    closeCategoryDetailModal: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedDetailModal = "";
    },
    openCategorySearchList: (state) => {
      state.isSearchList = "open";
    },
    closeCategorysearchList: (state) => {
      state.isSearchList = "";
    },
    salonaccessSearchName: (state, action) => {
      state.isSearchName = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(salonaccessStoreApi.pending, (state) => {
      state.isStoreError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessStoreApi: "loading" };
    })
    .addCase(salonaccessStoreApi.fulfilled, (state, action) => {
      state.isStoreError = "";
      if (state.isListView && state.isListView.data) {
        state.isListView.data = [action.payload, ...state.isListView.data];
      } else {
        state.isListView = { data: [action.payload] };
      }
      state.isApiStatus = { ...state.isApiStatus, salonaccessStoreApi: "succeeded" };
    })
    .addCase(salonaccessStoreApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessStoreApi: "failed" };
      state.isStoreError = salonAccessErrorMessage(action, "Unable to create salon access.");
    })
    .addCase(salonaccessUpdateApi.pending, (state) => {
      state.isUpdateError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessUpdateApi: "loading" };
    })
    .addCase(salonaccessUpdateApi.fulfilled, (state, action) => {
      const { id, ...changes } = action.payload;
      const existingData = state.isListView?.data?.find((event) => event.id === id);
      if (existingData) {
        Object.keys(changes).map((keyName) => {
          existingData[keyName] = changes[keyName];
        });
      }
      state.isUpdateError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessUpdateApi: "succeeded" };
    })
    .addCase(salonaccessUpdateApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessUpdateApi: "failed" };
      state.isUpdateError = salonAccessErrorMessage(action, "Unable to update salon access.");
    })
    .addCase(salonaccessListViewApi.pending, (state) => {
      state.isListViewError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessListViewApi: "loading" };
    })
    .addCase(salonaccessListViewApi.fulfilled, (state, action) => {
      let old_current_page = state.isListView.current_page ? state.isListView.current_page : "";
      let new_current_page = action.payload.current_page ? action.payload.current_page : "";
      let viewdata = state.isListView && state.isListView.data;
      let newviewdata = action.payload && action.payload.data;
      state.isListView = action.payload;
      if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
        viewdata && newviewdata ? (state.isListView.data = [...viewdata, ...newviewdata]) : action.payload;
      }
      state.isListViewError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessListViewApi: "succeeded" };
    })
    .addCase(salonaccessListViewApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessListViewApi: "failed" };
      state.isListViewError = salonAccessErrorMessage(action, "Unable to load salon access.");
    })
    .addCase(salonaccessSuggetionListApi.pending, (state) => {
      state.isSuggetionListViewError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessSuggetionListApi: "loading" };
    })
    .addCase(salonaccessSuggetionListApi.fulfilled, (state, action) => {
      let old_current_page = state.isSuggetionListView.current_page ? state.isSuggetionListView.current_page : "";
      let new_current_page = action.payload.current_page ? action.payload.current_page : "";
      let viewdata = state.isSuggetionListView && state.isSuggetionListView.data;
      let newviewdata = action.payload && action.payload.data;
      state.isSuggetionListView = action.payload;
      if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
        viewdata && newviewdata ? (state.isSuggetionListView.data = [...viewdata, ...newviewdata]) : action.payload;
      }
      state.isSuggetionListViewError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessSuggetionListApi: "succeeded" };
    })
    .addCase(salonaccessSuggetionListApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessSuggetionListApi: "failed" };
      state.isSuggetionListViewError = salonAccessErrorMessage(action, "Unable to load salon access suggestions.");
    })
    .addCase(salonaccessDetailApi.pending, (state) => {
      state.isDetailDataError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessDetailApi: "loading" };
    })
    .addCase(salonaccessDetailApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessDetailApi: "succeeded" };
      state.isDetailData = action.payload;
      state.isDetailDataError = "";
    })
    .addCase(salonaccessDetailApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessDetailApi: "failed" };
      state.isDetailDataError = salonAccessErrorMessage(action, "Unable to load salon access details.");
    })
    .addCase(salonaccessDeleteApi.pending, (state) => {
      state.isDeleteError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessDeleteApi: "loading" };
    })
    .addCase(salonaccessDeleteApi.fulfilled, (state, action) => {
      const { id } = action.payload;
      state.isApiStatus = { ...state.isApiStatus, salonaccessDeleteApi: "succeeded" };
      state.isListView.data = state.isListView?.data ? state.isListView.data.filter((item) => item.id != id) : state.isListView.filter((item) => item.id != id);
    })
    .addCase(salonaccessDeleteApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessDeleteApi: "failed" };
      state.isDeleteError = salonAccessErrorMessage(action, "Unable to delete salon access.");
    })
    .addCase(salonaccessOptions.pending, (state) => {
      state.isCategoryOptionError = "";
      state.isApiStatus = { ...state.isApiStatus, salonaccessOptions: "loading" };
    })
    .addCase(salonaccessOptions.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessOptions: "succeeded" };
      state.isCategoryOption = action.payload;
      state.isCategoryOptionError = "";
    })
    .addCase(salonaccessOptions.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonaccessOptions: "failed" };
      state.isCategoryOptionError = salonAccessErrorMessage(action, "Unable to load salon access options.");
    });
  },
});
// Action creators are generated for each case reducer function
export const { reset, openAddCategoryForm, closeAddCategoryForm, openEditCategoryForm, closeEditCategoryForm, openCategoryDetailModal, closeCategoryDetailModal, openCategorySearchList, closeCategorysearchList, salonaccessSearchName } = salonaccessSlice.actions;
export default salonaccessSlice.reducer;
